define('views/shared/panel/wallet',[
    'backbone',
    'views/shared/panel/panel',
    'text!views/shared/panel/wallet.html',
    'models/accounts/rebatesummary',
    'models/merchants/giftcard_collection',
    'models/linkedcards/linkedcard_collection'
], function(Backbone, PanelView, Template, RebatesModel, EcardsModel, LinkedCardsModel){
    'use strict';

    return PanelView.extend({
        id      : 'wallet-inner-container',
        tagName : 'div',
        isRender: true,
        template: _.template(Template),
        events  : {
            'click .js-wallet-transaction-history': 'goToTransactionHistory'
        },
        initialize: function(options){
            options = options || {};
            
            this.is_open = false;
            this.panel_type = 0;
            this.grouped_ecards = {};
            this.spending_account = options.spending_account;
            this.bank = options.bank;
            this.elementName = options.elementName;

            PanelView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            this.$('.js-wallet-transaction-history').on('click',function(){
                that.goToTransactionHistory(that);
            });

            return this;
        },

        loadData: function(){},

        updateSpendingAccount: function(spending_account){
            this.spending_account = spending_account;
        },

        updateBank: function(bank){
            this.bank = bank;
        },

        refresh: function(){
            this.getAllData();
            this.render();
        },

        getAllData: function(){
            // this.getRebates();
            this.getEcards();
            this.getLinkedCards();
            this.getBankStatus();
            this.checkForPFDebitCard();
        },

        getRebates: function(){
            var that = this;

            this.rebates_model = new RebatesModel({ instanceURL: pf.consumerURL + '/Rebates', limit: 3 });
            this.rebates_model.fetch({
                success: function(model, resp){
                    that.addRebates();
                },
                error: function(err,a,b,c){
                    console.log('getRebates error',err,a,b,c);
                }
            });
        },

        addRebates: function(){
            var rebates = this.rebates_model.toJSON(),
                month = (rebates.RebatesThisMonth) ? formatCurrency(rebates.RebatesThisMonth): formatCurrency(0.00),
                year = (rebates.RebatesThisYear) ? formatCurrency(rebates.RebatesThisYear): formatCurrency(0.00),
                total = (rebates.TotalRebates) ? formatCurrency(rebates.TotalRebates): formatCurrency(0.00);
            
            this.$('.js-rebate-cash-month').html('$'+month);
            this.$('.js-rebate-cash-year').html('$'+year);
            this.$('.js-rebate-cash-total').html('$'+total);
        },

        getBankStatus: function(){

            if(this.bank){

                if(this.bank.verificationstatus == 'undefined' || this.bank.verificationstatus == '0'){
                    /* No linked bank account */
                    this.noBankAccMsg();
                } else if(this.bank.verificationstatus != '2'){
                    /* Has linked bank account but hasn't verified, if it is equal to 2 then the bank account has been verified */
                    this.unverifiedBank();
                } else {
                    $('.js-bank-account-status').html('Verified');
                }

            } else {
                this.noBankAccMsg();
            }

        },

        noBankAccMsg: function(){
            $('.js-wallet-bank').hide();
            $('.js-wallet-add-bank').show();
        },

        unverifiedBank: function(){
            $('.js-bank-account-status').html('Verification Pending').addClass('unverified');
            $('.js-wallet-bank-info').show();
        },

        getLinkedCards: function(){
            var that = this;

            this.linked_cards = new LinkedCardsModel({ instanceURL: pf.consumerURL + '/LinkedCards?smc=true' });
            this.linked_cards.fetch({
                success: function(model, resp){
                    that.$('.js-linked-cards-count').html('('+resp.length+')');
                },
                error: function(){}
            });
        },

        getEcards: function(){
            var that = this;
            this.ecards_model = new EcardsModel();
            this.ecards_model.fetch({
                success: function(model, resp){
                    // TODO: Break logic out into another component
                    that.groupEcards();
                },
                error: function(){}
            });
        },

        groupEcards: function(){
            var ecards = this.ecards_model.toJSON();

            ecards.forEach(function(ecard){
                
                if(this.grouped_ecards.hasOwnProperty(ecard.MerchantGroupGUID)){
                    this.grouped_ecards[ecard.MerchantGroupGUID].push(ecard);
                } else {
                    this.grouped_ecards[ecard.MerchantGroupGUID] = [];
                    this.grouped_ecards[ecard.MerchantGroupGUID].push(ecard);
                }

            }, this);

            this.createEcardGroupList();
        },

        createEcardGroupList: function(){
            var html = '';

            for(var key in this.grouped_ecards){
                var ecards = this.grouped_ecards[key],
                    num = ecards.length,
                    name = ecards[0].GroupName,
                    logo = ecards[0].GiftCardImagelarge;
                
                html += [
                    '<li>',
                        '<a href="#merchants/groups/'+key+'" class="block a--unstyled">',
                            '<img src="'+logo+'" class="ecard-merchant-logo" alt="'+name+' Logo">',
                            '<span class="ecard-count">'+num+'</span>',
                        '</a>',
                    '</li>'
                ].join('');
            }
            
            this.$('.js-wallet-egift-cards').html(html);
        },

        checkForPFDebitCard: function(){
            if(pf.session.get('CardType') == enums.cardTypes.GPRDebitCard) {
                this.$('.js-wallet-pf-card-apply').hide();
            }
        },

        goToTransactionHistory: function(that){
            console.log('goToTransactionHistory',that);
            pf.navigate('#wallet/'+that.spending_account.accountguid);
        },

        close: function(){}
    });
});

